import React, { useContext } from 'react';
import Headline from 'components/headline';
import CreditCardSuccess from 'components/CreditCardComponents/CreditCardSuccess/CreditCardSuccess';
import { welcomeCard as WelcomeCard } from 'components/welcomeCard/welcomeCard';
import { ProfileStep5 } from 'components/newAccountSteps/profileSteps/ProfileStep5/ProfileStep5Container';
import { DocumentationInfo } from 'components/documentationInfo/DocumentationInfo/documentationInfo';
import { HtmlText, formatText } from 'core/i18n';
import { isMobile } from 'utilities/browser';
import { ACTIVATED, PRE_DOCUMENTATION, SUCCESS } from 'constants/statusProcess';
import { DocumentationViewContext } from '../context/DocumentationViewContext/DocumentationViewContext';

export const GetDocumentationView = ({ isDocumentRetry, isDocumentationLoaded, isDocumentationUploaded, status }) => {
    const { shouldShowQRPage } = useContext(DocumentationViewContext);

    const getHeadlineSubtitleKeys = shouldShowQRPage => {
        if (shouldShowQRPage) return 'uploads-qrHeadlineSubtitle';
        if (isMobile()) return 'uploads-uploadDocumentHere';

        return 'contentStepsTitles-attachImages';
    };

    const createHeadlineSubtitle = shouldShowQRPage => HtmlText(formatText(getHeadlineSubtitleKeys(shouldShowQRPage)));

    const isPreDocumentation = status === PRE_DOCUMENTATION;
    const isSuccess = status === SUCCESS;
    const isActivated = status === ACTIVATED;

    if (!isDocumentationLoaded && !isPreDocumentation) return null;

    if (isSuccess || isActivated) {
        return <CreditCardSuccess />;
    }

    if (isDocumentationUploaded) {
        return (
            <>
                <DocumentationInfo />
                <WelcomeCard />
            </>
        );
    }

    return (
        <div className="basic-layering">
            <Headline icon="documentos" className="prospects-gutter">
                <h2>{formatText('contentStepsTitles-FinallyDocuments')}</h2>
                <p>{createHeadlineSubtitle(shouldShowQRPage)}</p>
            </Headline>
            <ProfileStep5 />
            {!isDocumentRetry() && <WelcomeCard />}
        </div>
    );
};
